<template>
  <div class="add">
    <div>
      <van-nav-bar @click-left="onClickLeft" title="编辑收货地址" left-arrow />
    </div>
    <div class="on_address">
      <van-form @submit="onSubmit" validate-first validate-trigger="onChange">
        <van-field
          v-model="username"
          name="receiverMan"
          label="收货人"
          placeholder="收货人姓名"
          :rules="[{ required: true, message: '请填写收货人姓名' }]"
        />
        <van-field
          v-model="phoneNum"
          name="phoneNum"
          label="手机号码"
          placeholder="收货人手机号"
          :rules="[{ pattern, required: true, message: '请填写收货人手机号' }]"
        />
        <van-field
          class="is_area"
          readonly
          clickable
          name="area"
          :value="value"
          label="省份"
          placeholder="省市区县、乡镇等"
          @click="showArea = true"
          :rules="[{ required: true, message: '请选择省份' }]"
        ></van-field>
        <van-field
          readonly
          clickable
          name="street"
          :value="streets"
          label="街道"
          placeholder="请选择街道"
          @click="showStreet = true"
          :rules="[{ required: true, message: '请选择街道' }]"
        ></van-field>
        <van-field
          v-model="message"
          rows="1"
          name="isAddress"
          autosize
          label="详细地址"
          type="textarea"
          placeholder="如道路、门牌号、小区、楼栋号、单元室等"
          :rules="[{ message: '请填写详细地址' }]"
        />
        <!-- 省市区 -->
        <van-popup v-model="showArea" position="bottom">
          <van-area
            :area-list="areaList"
            @confirm="onConfirm"
            :value="areaValue"
            @cancel="showArea = false"
          />
        </van-popup>
        <!-- 街道 -->
        <van-popup v-model="showStreet" position="bottom">
          <van-picker
            show-toolbar
            :columns="streetArrayCode"
            @confirm="onStreet"
            @cancel="showStreet = false"
          />
        </van-popup>
        <van-field name="switch" label="设为默认收货地址" class="to_switch">
          <template #input>
            <van-switch v-model="switchChecked" size="20" />
          </template>
        </van-field>

        <div>
          <van-button round block type="info" native-type="submit"
            >保存</van-button
          >
        </div>
      </van-form>
      <div @click="deleteAdr" class="delete_adr">删除收货地址</div>
      <div v-if="nowExpress.deliveryMethod == 2" class="store-explain">
        商家配送范围:{{ ProvincialMunicipalities
        }}{{ streetExplainTxt }}可支持同城配送
      </div>
      <van-dialog
        class="showWarn"
        v-model="warn"
        @confirm="warnConfirm"
        show-cancel-button
      >
        <div>确定删除该地址？</div>
      </van-dialog>
    </div>
    <toast-show :showMessage="showMessage" :showToast="showToast" />
  </div>
</template>

<script>
import areaList from '@/assets/js/area.js'
import streetData from '@/assets/js/pcas-code.json'
import toastShow from '@/components/content/toastShow'
import {
  getAddressList,
  upChangeData,
  deleteAddress,
} from '@/api/shippingAddress'

export default {
  name: 'Isaddress',
  components: {
    toastShow,
  },
  data() {
    return {
      // 接口
      cityDistributionScope: window.localStorage.getItem('distributionScope'),
      cityCodes: [],
      codeSixArry: [],
      showMessage: '',
      showToast: false,
      hasShow: false,
      province: '',
      streetCodes: '',
      streetArrayCode: [],
      streetArray: [],
      showStreet: false,
      country: [],
      address1: '',
      address2: '',
      address3: '',
      // areaName: '',
      areaValue: '',
      status: '',
      // 结束
      pattern: /(^0\d{2,3}[-－]\d{7}$)|(^1[3|4|5|6|7|8|9][0-9]{9}$)/,
      // switchChecked: false,
      areaList,
      username: '',
      phoneNum: '',
      value: '',
      streets: '',
      showArea: false,
      message: '',
      warn: false,
      list: [],
      listItem: {},
      shippingAdress: {
        addressCode: '',
        contacts: '',
        detailsAddress: '',
        firstChoice: '',
        phoneNumber: '',
        id: '',
        province: '',
      },
    }
  },
  computed: {
    // 默认地址
    switchChecked: {
      get() {
        for (let i = 0; i < this.list.length; i++) {
          return this.list[i].firstChoice
        }
      },
      set(vals) {
        for (let i = 0; i < this.list.length; i++) {
          this.list[i].firstChoice = vals
        }
      },
    },
  },
  created() {
    this.getMyAddressList()
    window.document.title = '编辑地址'
    this.status = this.$route.query.status
    this.nowExpress = this.$route.query

    if (this.$route.query.addressCode) {
      this.areaValue = this.$route.query.addressCode.substr(0, 6)
    }
    console.log('this.$route.query', this.$route.query)
    console.log('this.areaValue', this.areaValue)
    if (this.nowExpress.deliveryMethod === 2) {
      this.cityCode()
    }
  },
  methods: {
    // 匹配配送code和显示配送范围说明
    cityCode() {
      console.log('cityDistributionScope', this.cityDistributionScope)
      this.cityCodes = this.cityDistributionScope.split(',')
      console.log('cityCodes', this.cityCodes)
      this.codeSixArry = []
      this.cityCodes.forEach((el) => {
        this.codeSixArry.push(el.substr(0, 6))
      })
      // console.log('codeSixArry', this.codeSixArry)
      // 显示商家配送范围说明
      if (this.cityCodes.length === 0) {
        console.log('没有配送范围')
        return
      }
      if (this.nowExpress.deliveryMethod === 2) {
        let explainArr = []
        explainArr = streetData.filter((val) => {
          return val.code === this.cityCodes[0].substr(0, 2)
        })
        const addressProvince = explainArr[0].name
        console.log('explainArrexplainArr', explainArr)

        let explainArr1 = []
        if (explainArr.length !== 0) {
          explainArr1 = explainArr[0].children.filter((val) => {
            return val.code === this.cityCodes[0].substr(0, 4)
          })
        }
        console.log('explainArr1explainArr1', explainArr1)
        const addressCity = explainArr1[0].name

        let explainArr2 = []
        if (explainArr1.length !== 0) {
          explainArr2 = explainArr1[0].children.filter((val) => {
            return val.code === this.cityCodes[0].substr(0, 6)
          })
        }
        // console.log('explainArr2[0]', explainArr2[0])
        const addressCityLevel = explainArr2[0].name
        this.ProvincialMunicipalities =
          addressProvince + addressCity + addressCityLevel
        const streetExplain = []
        explainArr2[0].children.forEach((value) => {
          console.log('value', value)
          this.cityCodes.forEach((el) => {
            // console.log('5555555555555', el)
            if (el === value.code) {
              streetExplain.push(value.name)
            }
          })
          console.log('streetExplain', streetExplain)
          if (streetExplain.length > 0) {
            this.streetExplainTxt = streetExplain.join('、')
          }
        })
      }
    },
    onStreet(el, i) {
      // 同城配送
      if (this.nowExpress.deliveryMethod === 2 && !this.hasShow) {
        const exist = this.cityCodes.indexOf(this.streetArray[i].code) !== -1
        console.log('cccccccc', exist)
        if (exist) {
          this.streets = el
          this.streetCodes = this.streetArray[i].code
          this.showStreet = false
        } else {
          this.hasToast('您选择地区不在配送范围请确认产品配送范围')
          this.streetCodes = ''
          this.streets = ''
          this.showStreet = true
        }
      } else {
        this.streets = el
        this.streetCodes = this.streetArray[i].code
        console.log('333333333', this.areaValue)
        this.showStreet = false
      }
    },
    // 筛选出街道
    getStreetArray() {
      console.log('this.areaValue', this.areaValue)
      if (this.areaValue === '') {
        return console.log('areaValue为空')
      }
      let streetArr = []
      streetArr = streetData.filter((val) => {
        return val.code === this.areaValue.substr(0, 2)
      })
      console.log('streetArr[0]', streetArr[0])
      this.address1 = streetArr[0].name

      let streetArr1 = []
      if (streetArr.length !== 0) {
        streetArr1 = streetArr[0].children.filter((val) => {
          return val.code === this.areaValue.substr(0, 4)
        })
      }
      console.log('streetArr1[0]', streetArr1[0])
      this.address2 = streetArr1[0].name

      let streetArr2 = []
      if (streetArr1.length !== 0) {
        streetArr2 = streetArr1[0].children.filter((val) => {
          console.log('valvalval', val, this.areaValue.substr(0))
          let hasAreaValue
          if (this.nowExpress.status === 2) {
            hasAreaValue = this.areaValue.substr(0, 6)
          } else if (this.nowExpress.expressStatus === 3) {
            hasAreaValue = this.areaValue.substr(0, 6)
          } else if (this.nowExpress.status === 1) {
            hasAreaValue = this.areaValue.substr(0, 6)
          } else {
            hasAreaValue = this.areaValue.substr(0, 6)
          }
          // return val.code === this.areaValue.substr(0)
          return val.code === hasAreaValue
        })
      }

      this.streetArray = []
      this.streetArrayCode = []
      console.log('streetArr2[0]', streetArr2)
      this.address3 = streetArr2[0].name
      this.value = this.address1 + '/' + this.address2 + '/' + this.address3
      streetArr2[0].children.forEach((value) => {
        this.streetArray.push(value)
        this.streetArrayCode.push(value.name)
        // 同城配送
        if (!this.hasShow && this.nowExpress.deliveryMethod === 2) {
          console.log('cityCodes11111111111111', this.cityCodes)
          if (this.cityCodes.length === 0) {
            this.streets = '无可选街道'
            return
          }
          // 默认选第一个街道
          let exist = ''
          this.streetArray.some((item, i) => {
            exist = this.cityCodes.indexOf(this.streetArray[i].code) !== -1
            if (exist) {
              this.streets = this.streetArray[i].name
              this.streetCodes = this.streetArray[i].code
              return true
            }
          })
          console.log('existexistexist', exist)
        } else {
          // 没有街道的情况
          if (this.streetArray.length === 0) {
            this.streets = '无可选街道'
            return
          }
          // 默认选择第一个街道code
          // if (!this.streetCodes) {
          //   this.streetCodes = this.streetArray[0].code
          //   console.log('2222222222222', this.areaValue)
          // }
          // 默认选第一个街道和code
          this.streetCodes = this.streetArray[0].code
          this.streets = this.streetArray[0].name
          console.log('dddddddddddddddddddddd')
        }
      })
      // this.streetCodes = this.streetArrayCode[0]
    },
    // 后台数据list
    getMyAddressList() {
      const that = this
      getAddressList({
        id: this.$route.query.id,
      })
        .then((res) => {
          this.list = res.data.data
          console.log('this.list', this.list)
          if (res.data.code === 200) {
            this.list.forEach(function (value, index) {
              const ids = that.$route.query.id
              if (value.id === ids) {
                that.listItem = value
                that.username = that.listItem.contacts
                that.phoneNum = that.listItem.phoneNumber
                that.message = that.listItem.detailsAddress
                if (!that.areaValue) {
                  that.areaValue = that.listItem.addressCode
                }
                if (that.listItem.addressCode) {
                  that.getStreetArray()
                }
                // that.areaName = that.listItem.addressCode
              }
            })
          }
        })
        .catch((err) => {
          console.log('错误', err)
        })
    },
    deleteAdr() {
      this.warn = true
    },
    warnConfirm() {
      // 删除收货地址
      console.log('id', this.$route.query.id)
      deleteAddress(this.$route.query.id).then((res) => {
        if (res.data.code === 200) {
          console.log('成功')
          if (this.nowExpress.status === 2) {
            this.$router.replace({
              path: '/mall/myaddress',
              query: this.nowExpress,
            })
          } else if (this.nowExpress.status === 1) {
            this.$router.replace({
              path: '/mall/myaddress',
              query: this.nowExpress,
            })
            console.log('this.nowExpress删除', this.nowExpress)
          } else if (this.nowExpress.expressStatus === 3) {
            this.$router.replace({
              path: '/mall/myaddress',
              query: this.nowExpress,
            })
          } else {
            this.$router.replace({
              path: '/mall/myaddress',
            })
          }
        }
      })
    },
    onConfirm(values) {
      console.log('values', values)
      for (let i = 0; i < values.length; i++) {
        if (i === 2) {
          this.areaValue = values[2].code
        }
      }
      this.value = values.map((item) => item.name).join('/')
      this.province = values.map((item) => item.name).join('')
      if (this.nowExpress.deliveryMethod === 2) {
        this.codeSixArry.forEach((item, i) => {
          if (item === this.areaValue) {
            this.showArea = false
            this.hasShow = false
          } else {
            this.hasToast('您选择地区不在配送范围请确认产品配送范围')
            this.streetCodes = ''
            this.areaValue = ''
            this.value = ''
            this.streets = ''
            this.showArea = true
            this.hasShow = true
            this.streetArrayCode = []
            this.streetArray = []
            return
          }
        })
      }
      this.getStreetArray()
      if (this.hasShow) {
        // console.log('2');
      } else {
        this.showArea = false
      }
    },
    // 提交保存
    onSubmit(values) {
      console.log('submit', values)
      if (this.value) {
        this.province = this.value
      }
      this.shippingAdress = {
        contacts: values.receiverMan,
        detailsAddress: values.isAddress,
        // detailsAddress: values.street + values.isAddress,
        firstChoice: values.switch,
        phoneNumber: values.phoneNum,
        // addressCode: this.areaValue,
        addressCode: this.streetCodes,
        // addressCode: this.addressCode,
        id: this.$route.query.id,
        province: this.province,
      }
      this.updataAdd()
      console.log('提交保存最后')
    },
    // // 更新收货地址
    updataAdd() {
      console.log('更新前', this.shippingAdress)
      upChangeData(this.shippingAdress).then((res) => {
        const intId = parseInt(this.shippingAdress.id)
        console.log('this.province', this.province)
        if (this.province) {
          this.nowExpress.province = this.province
        }
        if (res.data.code === 200) {
          console.log('更新')
          // location.reload()
          console.log(
            'this.nowExpressthis.nowExpressthis.nowExpress',
            this.nowExpress
          )
          if (this.nowExpress.status === 1) {
            this.nowExpress.shippingAddressId = intId
            this.$router.replace({
              path: '/mall/order-nowpayexpress',
              query: this.nowExpress,
            })
          } else if (this.nowExpress.status === 2) {
            this.$router.replace({
              path: '/mall/order-cartfastmail',
              query: {
                deliveryMethod: this.nowExpress.deliveryMethod,
                shippingAddressId: intId,
                storeId: this.$route.query.storeId,
                items: this.$route.query.items,
                province: this.province,
              },
            })
          } else if (this.nowExpress.expressStatus === 3) {
            this.nowExpress.shippingAddressId = intId
            this.$router.replace({
              path: '/mall/order-nowpayexpress',
              query: this.nowExpress,
            })
          } else if (this.$route.query.from == 'freetake') {
            let query = {}
            Object.assign(query, this.$route.query)
            this.$router.replace({
              path: '/mall/myaddress',
              query: query,
            })
          } else {
            this.$router.replace({ path: '/mall/myaddress' })
          }
        }
      })
    },
    onClickLeft() {
      if (this.$getIsApp()) {
        this.$callApp('Android', 'GoBackAppMethod', '')
        this.$callApp('iOS', 'GoBackAppMethod', '')
      } else {
        this.$router.replace({
          path: '/mall/myaddress',
          query: this.$route.query,
        })
      }
    },
    hasToast(message) {
      this.showMessage = message
      this.showToast = true
      setTimeout(() => {
        this.showToast = false
      }, 2000)
    },
  },
}
</script>

<style lang="less" scoped>
/deep/ .van-icon {
  color: black;
  font-size: 18px;
}
.add {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: #efefef;
}
//navbar
/deep/ .van-nav-bar {
  background-color: #efefef;
  height: 44.5px;
  line-height: 44.5px;
  .van-nav-bar__arrow + .van-nav-bar__text {
    font-size: 18px;
    color: black;
  }
  .van-nav-bar__arrow {
    font-size: 18px;
  }
}
//地址组件
/deep/ .on_address {
  position: relative;
  //不标红
  .van-field--error .van-field__control,
  .van-field--error .van-field__control::placeholder {
    color: #9fa0a0;
  }
  .location {
    img {
      width: 11.5px;
      height: 16.5px;
      padding-right: 3.5px;
    }
    color: black;
    padding: 1.5px;
    font-size: 12px;
    position: absolute;
    top: 122.5px;
    right: 15px;
    height: 15px;
  }
  .to_switch {
    margin-top: 5px;
  }
  // .van-cell__value {
  //   display: block;
  // }
  // .van-cell .van-field {
  //   height: 47px;
  // }
  // .van-cell__value .van-field__value {
  //   height: 47px;
  //   line-height: 45px;
  // }
  .van-field__control {
    padding-left: 15px;
    font-size: 12px;
  }
  .van-field__label {
    width: auto;
  }
  .van-field__error-message {
    font-size: 12px;
    padding-left: 15px;
  }
  .van-cell__title {
    font-size: 14px;
    color: black;
  }
}
//地区弹窗
/deep/ .van-picker__toolbar {
  height: 40px;
  line-height: 40px;
}
/deep/ .van-picker-column__item {
  font-size: 15px;
}
/deep/ .van-picker__cancel,
/deep/ .van-picker__confirm {
  font-size: 13px;
}
//保存按钮
.van-button--block {
  position: fixed;
  bottom: 0px;
}
.van-button--round {
  border: none;
  border-radius: 0;
  height: 44.5px;
  font-size: 15px;
  background: @discount-price;
}

//提示警告框
/deep/ .showWarn {
  height: 97px;
  width: 275px;
  .van-dialog__content {
    text-align: center;
    height: 60px;
    line-height: 60px;
    font-size: 15px;
    color: black;
  }
  .van-dialog__footer--buttons,
  .van-button--default {
    height: 37px;
    line-height: 37px;
  }
  .van-button__text {
    font-size: 15px;
  }
}
//删除地址
.delete_adr {
  margin-top: 5px;
  background: #fff;
  height: 36px;
  line-height: 36px;
  font-size: 12px;
  color: #e60012;
  padding-left: 8.5px;
}
//配送范围
.store-explain {
  text-indent: 17.5px;
  padding: 10px 10px;
  color: #cc0033;
  font-size: 12.5px;
}
</style>
